import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export const getDownloadDocumentToken = withNextApi<
  GetDownloadDocumentTokenResponse,
  GetDownloadDocumentTokenParameters
>("/cvp/CvpGetDownloadDocumentToken");

export interface GetDownloadDocumentTokenParameters extends NextApiParams {
  idDocument: number;
}

export interface GetDownloadDocumentTokenResponse extends BackendResponse {
  item: string;
}
